"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lp_api_client_1 = require("../../lib/lp_api_client");
var lp_grid_card_1 = require("./lp_grid_card");
var overflowing_row_1 = require("@reverbdotcom/commons/dist/components/overflowing_row");
var tiles_1 = require("@reverbdotcom/commons/dist/components/tiles");
var hash_util_1 = require("../../reverb-js-common/hash_util");
var map_ajax_to_props_1 = require("../map_ajax_to_props");
var LPAlbumRowEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(LPAlbumRowEmbed, _super);
    function LPAlbumRowEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPAlbumRowEmbed.prototype.shouldBeNarrow = function () {
        return this.props.albums.length <= 4;
    };
    LPAlbumRowEmbed.prototype.shouldCenterTitle = function () {
        return !this.props.url;
    };
    LPAlbumRowEmbed.prototype.getAlbums = function () {
        if (this.props.newestFirst) {
            return this.props.albums.reverse();
        }
        return this.props.albums;
    };
    LPAlbumRowEmbed.prototype.renderLink = function (text) {
        return (React.createElement("a", { href: this.props.url, target: "_blank", rel: "noopener noreferrer" }, text));
    };
    LPAlbumRowEmbed.prototype.renderTitle = function () {
        if (!this.props.url) {
            return this.props.title;
        }
        return this.renderLink(this.props.title);
    };
    LPAlbumRowEmbed.prototype.renderAction = function () {
        if (!this.props.url) {
            return null;
        }
        return this.renderLink(I18n.t('discovery.listingsRow.seeMore'));
    };
    LPAlbumRowEmbed.prototype.render = function () {
        var _this = this;
        return (React.createElement(overflowing_row_1.default, { title: this.renderTitle(), action: this.renderAction(), narrow: this.shouldBeNarrow(), centeredTitle: this.shouldCenterTitle(), collectionCount: this.props.albums.length },
            React.createElement(tiles_1.default, { singleRow: true, centered: this.shouldBeNarrow(), expectedCount: this.props.slugs.length }, this.getAlbums().map(function (album, idx) { return (React.createElement(lp_grid_card_1.default, { key: idx, title: album.title, url: lp_api_client_1.albumShow.expand({ slug: album.slug }), image: hash_util_1.getLink(album.images[0], 'thumb_large'), artist: album.artists.map(function (a) { return a.name; }).join(', '), inventory: album.listing_count, fromPrice: album.lowest_price.display, toPrice: album.highest_price.display, trackName: _this.props.trackName })); }))));
    };
    LPAlbumRowEmbed.defaultProps = {
        albums: [],
    };
    return LPAlbumRowEmbed;
}(React.Component));
exports.LPAlbumRowEmbed = LPAlbumRowEmbed;
function fetcher(props) {
    return lp_api_client_1.default.albums(props.slugs).then(function (resp) {
        var albums = resp.albums;
        return { albums: albums };
    });
}
exports.fetcher = fetcher;
exports.default = map_ajax_to_props_1.default(fetcher)(LPAlbumRowEmbed);
//# sourceMappingURL=lp_album_row_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/lp_album_row_embed.js
// module id = rp/8
// module chunks = 20 21